module.exports = __webpack_public_path__ + "static/media/icons_coude.ef3056b7.svg";